module.exports = ".row.inactive {\n  opacity: 0.4; }\n\n.fa-close, .fa-edit, .fa-check-circle {\n  cursor: pointer; }\n\n.fa-close.read-only, .fa-edit.read-only, .fa-check-circle.read-only {\n  opacity: 0.4;\n  cursor: not-allowed; }\n\ntable tr:last-child td {\n  border-top: 2px solid #EAEAEA; }\n\n.nth-message {\n  position: absolute;\n  left: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/schemas/components/schema.component.scss
// module id = 576
// module chunks = 1